import React from 'react'
import './Heading.css'

const Heading = () => {
  return (
    <div className='Head'>
   <h1 className='heading'>Tic-tac-toe</h1>
    </div>
  )
}

export default Heading